import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./Extend_Service_Modal.css";
import { Form } from "react-bootstrap";
import ModalSave from "../../ModalSave";
import { CancelButton, SaveButton } from "../../Button";
import { postData } from "../../../../utils/api";

const Extend_Service_Modal = ({ show, onHide, extended, getDataAll }) => {
 const formatMonth = (value) => {
   if (!value) return "";

   let date;

   if (value.length === 7) {
     // Case: YYYY-MM → default day = 01
     const [year, month] = value.split("-");
     date = new Date(year, month - 1, 1);
   } else {
     // Case: YYYY-MM-DD
     date = new Date(value);
   }

   return date.toLocaleDateString("en-US", {
     day: "2-digit",
     month: "short",
     year: "numeric",
   });
 };

  const [startMonth, setStartMonth] = useState("");
  const [endMonth, setEndMonth] = useState("");
  const [errors, setErrors] = useState({});

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const validate = () => {
    let err = {};

    if (!startMonth) err.startMonth = "Start month is required.";
    if (!endMonth) err.endMonth = "End month is required.";

    if (startMonth && endMonth) {
      if (new Date(endMonth) <= new Date(startMonth)) {
        err.endMonth = "End month must be greater than start month.";
      }
    }

    // OPTIONAL: Prevent selecting a start month before last end month
    // if (extended?.end_month && startMonth) {
    //   if (new Date(startMonth) <= new Date(extended.end_month)) {
    //     err.startMonth = `Start month must be after last end month (${formatMonth(
    //       extended.end_month
    //     )}).`;
    //   }
    // }

    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const ChangeStatus = async () => {
    if (!validate()) return;

    const data = {
      start_month: startMonth,
      end_month: endMonth,
    };

    const response = await postData(
      `/masters/customer/extend-service/${extended?.id}`,
      data,
    );

    if (response.success) {
      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => {
        getDataAll();
        setShowModal(0);
        onHide();
      }, 1000);
    } else {
      setShowModal({ code: response.code, message: response.message });
      setTimeout(() => setShowModal(0), 1000);
    }
  };

  return (
    <Modal
      className="common_modal Extend_Service_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Extend</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="main_div">
          <div className="top_div">
            <p className="label_text">
              Last Start Month:{" "}
              <span className="inner_text">
                {formatMonth(extended?.start_month)}
              </span>
            </p>

            <p className="label_text">
              Last End Month:{" "}
              <span className="inner_text">
                {formatMonth(extended?.end_month)}
              </span>
            </p>
          </div>

          <div className="form_holder">
            <Form>
              <div className="row">
                <div className="col-lg-6">
                  <Form.Group className="mb-3">
                    <Form.Label>Start Month</Form.Label>
                    <Form.Control
                      type="date"
                      value={startMonth}
                      min={new Date().toISOString().slice(0, 7)}
                      onChange={(e) => {
                        setStartMonth(e.target.value);
                        if (errors.startMonth) validate();
                      }}
                    />
                    {errors.startMonth && (
                      <p className="error-text">{errors.startMonth}</p>
                    )}
                  </Form.Group>
                </div>

                <div className="col-lg-6">
                  <Form.Group className="mb-3">
                    <Form.Label>End Month</Form.Label>
                    <Form.Control
                      type="date"
                      value={endMonth}
                      min={new Date().toISOString().slice(0, 7)}
                      onChange={(e) => {
                        setEndMonth(e.target.value);
                        if (errors.endMonth) validate();
                      }}
                    />
                    {errors.endMonth && (
                      <p className="error-text">{errors.endMonth}</p>
                    )}
                  </Form.Group>
                </div>
              </div>

              <div className="btn_holder tab-radio">
                <CancelButton name="Cancel" handleClose={onHide} />
                <SaveButton name="Save" handleSubmit={ChangeStatus} />
              </div>
            </Form>
          </div>
        </div>
      </Modal.Body>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </Modal>
  );
};

export default Extend_Service_Modal;
